module.exports = __webpack_public_path__ + "75686f12cdbdd194c901e7de8ccb5ecd.svg";